import React from "react";
import FrontHeader from "../../shared/FrontHeader/FrontHeader";
import FrontFooter from "../../shared/FrontFooter/FrontFooter";
import illustration from "../../../assets/images/appImages/illustration.png";
import aboutImg from "../../../assets/images/appImages/aboutimg.png";
import vcover from "../../../assets/images/appImages/vcover.png";
import ReactPlayer from "react-player";
import { TeamData } from "./data";


export const CustomBeautyTitle = ({ title }: { title: string }) => {
  return <h2 className="custom-esb-title">{title}</h2>;
};

const TeamCard = ({
  photo,
  name,
  role,
  twitter,
  facebook,
  linkedin,
}: {
  photo?: string;
  name: string;
  role: string;
  twitter?: string;
  facebook?: string;
  linkedin?: string;
}) => {
  return (
    <div className="team-card">
      <span className="photo-wrapper">
        <img loading="lazy" src={photo} alt="photo" />
      </span>
      <span className="name">{name}</span>
      <span className="role">{role}</span>
    </div>
  );
};



function WhoWeAre() {
  return (
    <div className="landing-page-component">
      <FrontHeader />
      <div className="page-content who-we-are-page pb-5 pb-5">
        <h1 className="custom-page-title">Qui sommes-nous ?</h1>
        <div className="who-we-are">
          <div className="container">
            <div className="row">
              <div className="col-md-6 mb-4">
                <div className="illustration-container">
                  <img loading="lazy" src={illustration} alt="image" />
                </div>

              </div>
              <div className="col-md-6 mb-4">
                <CustomBeautyTitle title="Qui sommes nous?" />
                <h3 className="custom-title">NOUROU SHILAJIT</h3>
                <div className="custom-content">
                  NOUROU SHILAJIT est une entreprise spécialisée dans la vente de produits naturels, notamment le Shilajit, pour améliorer l’énergie,
                  la vitalité et la santé de nos clients. Basée à Dakar, notre mission est d’aider les Sénégalais à prendre soin de leur bien-être
                  grâce à des produits authentiques et de qualité.
                </div>
              </div>
            </div>
          </div>
          <div className="py-5 who-we-are">
            <div className="container">
              <div className="row">
                <div className="col-md-12 mb-4">
                  <CustomBeautyTitle title="Valeurs" />
                  <h3 className="custom-title">Nos valeurs</h3>
                  <div className="custom-content-wrapper">
                    <p className="pb-2 para custom-content">
                      <strong>Qualité : </strong>Garantir des produits naturels authentiques et efficaces.
                    </p>
                    <p className="pb-2 para custom-content">
                      <strong>Santé : </strong>Promouvoir le bien-être physique et mental.
                    </p>
                    <p className="pb-2 para custom-content">
                      <strong>Confiance :</strong> Offrir un service transparent et fiable à nos clients.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="about-us mt-5">
            <h3 className="title-home-page-theme text-center">
              Le shilajit, qu’est-ce que c’est ?
            </h3>
            <div className="who-we-are who-we-are-page">
              <div className="container">
                <div className="row">
                  <div className="col-md-6 mb-4">
                    <div className="custom-content">
                      Le shilajit est une substance naturelle résineuse, de couleur noire ou brun foncé, qui provient principalement des montagnes de l’Himalaya,
                      mais également d’autres régions montagneuses comme l’Altai, le Caucase ou le Tibet. Formée par la décomposition lente de matières organiques
                      et végétales sur des siècles, cette résine est largement utilisée en médecine traditionnelle, notamment dans l’ayurveda, pour ses nombreuses
                      propriétés supposées bénéfiques pour la santé.
                    </div>
                  </div>
                  <div className="col-md-6 mb-4">
                    <div className="illustration-container">
                      <img loading="lazy" src={aboutImg} alt="image" />
                    </div>
                  </div>
                </div>
                <p className="pb-3 custom-content">
                  Le shilajit est donc souvent qualifié de "superaliment" en raison de ses vertus supposées, bien que certaines nécessitent encore des preuves
                  scientifiques plus approfondies.
                </p>
                <p className="para custom-content">
                  <strong>Utilisation : </strong><br />
                  Disponible sous forme de résine, de poudre ou de capsules, le shilajit se consomme souvent en petites quantités, mélangé à de l’eau ou
                  du lait chaud.
                </p>
              </div>
            </div>
          </div>

          <div className="pb-0 who-we-are">
            <div className="container">
              <h3 className="custom-title pb-3 text-center">
                Les bienfaits du shilajit
              </h3>
              <div className="row video-row">
                <div className="col-md-6 mb-4">
                  <div className="illustration-container">
                    <ReactPlayer
                      className="custom-video video__player"
                      light={vcover}
                      controls
                      src="https://youtu.be/9Qw0QVuJVTQ"
                    />
                  </div>
                </div>
                <div className="col-md-6 mb-4">
                  <div className="illustration-container">
                    <ReactPlayer
                      className="custom-video video__player"
                      light={vcover}
                      controls
                      src="https://youtu.be/h7LWxHrr7N4"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="pb-0 who-we-are">
            <div className="container">
              <CustomBeautyTitle title="Team" />
              <h3 className="custom-title">Mot du fondateur</h3>
              <div className="custom-content">
                Chez NOUROU SHILAJIT, nous croyons que la santé et le bien-être sont essentiels. <br />
                Nous nous engageons à offrir des produits naturels de haute qualité et à accompagner nos
                clients dans leur quête d’une vie saine et équilibrée.
              </div>
            </div>
          </div>

          <div className="my-5 our-team gray_sky">
            <div className="container">
              <CustomBeautyTitle title="Team" />
              <h3 className="custom-title">Notre équipe</h3>
              <div className="row pt-4">
                {!!TeamData &&
                  TeamData.map((member, key) => {
                    return (
                      <div className="col-lg-3 col-md-4 mb-4 card-wrapper" key={key}>
                        <TeamCard
                          photo={member.photo}
                          name={member.name}
                          role={member.role}
                        />
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>

        </div>

      </div>
      <div style={{ padding: '5rem 0' }}></div>
      <FrontFooter />
    </div>
  );
}

export default WhoWeAre;
